var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeHeroBrunoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4363 0H13.5637C6.07268 0 0 6.07267 0 13.5637V39.4363C0 46.9273 6.07268 53 13.5637 53H39.4363C46.9273 53 53 46.9273 53 39.4363V13.5637C53 6.07267 46.9273 0 39.4363 0Z",
    fill: "#EC4024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5898 26.6064C32.0218 26.6064 35.6142 30.1989 35.6142 34.6308C35.6142 39.0628 32.0218 42.6552 27.5898 42.6552",
    stroke: "white",
    strokeWidth: 4.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5898 10.5566C32.0218 10.5566 35.6142 14.1491 35.6142 18.581C35.6142 23.013 32.0218 26.6054 27.5898 26.6054",
    stroke: "white",
    strokeWidth: 4.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1546 24.2871H18.9023V28.8998H32.1546V24.2871Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5156 20.2614V34.9439H18.903V15.6475C21.4496 15.6475 23.5156 17.7148 23.5156 20.2601V20.2614Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0293 30.0201V15.649H27.6419V34.6328C25.0953 34.6328 23.0293 32.5655 23.0293 30.0201Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHeroBrunoLogo);
export default __webpack_public_path__ + "static/media/home_hero_bruno_logo.7ec8906aca12de57c32ae7707d85d7b6.svg";
export { ForwardRef as ReactComponent };